import { render, staticRenderFns } from "./card-dual-image.vue?vue&type=template&id=3e94fbc4&"
import script from "./card-dual-image.vue?vue&type=script&lang=js&"
export * from "./card-dual-image.vue?vue&type=script&lang=js&"
import style0 from "./card-dual-image.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports